module.exports = __webpack_public_path__ + "static/media/spada-traders.10ec99f0.png";